export default {"src":"/_next/static/media/appStore.696de765.svg","height":56,"width":168,"blurWidth":0,"blurHeight":0};